/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_st_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. 12, 15, 18, 21, 24`)
};

const es_st_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`p. ej. 12, 15, 18, 21, 24`)
};

const de_st_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. 12, 15, 18, 21, 24`)
};

const nl_st_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bijv. 12, 15, 18, 21, 24`)
};

const fr_st_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. 12, 15, 18, 21, 24`)
};

const it_st_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`es. 12, 15, 18, 21, 24`)
};

const pt_br2_st_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex.: 12, 15, 18, 21, 24`)
};

const pt_st_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex.: 12, 15, 18, 21, 24`)
};

const ja_st_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例: 12, 15, 18, 21, 24`)
};

const zh_st_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如：12, 15, 18, 21, 24`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const st_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.st_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("st_placeholder", locale)
	if (locale === "en") return en_st_placeholder(inputs)
	if (locale === "es") return es_st_placeholder(inputs)
	if (locale === "de") return de_st_placeholder(inputs)
	if (locale === "nl") return nl_st_placeholder(inputs)
	if (locale === "fr") return fr_st_placeholder(inputs)
	if (locale === "it") return it_st_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_st_placeholder(inputs)
	if (locale === "pt") return pt_st_placeholder(inputs)
	if (locale === "ja") return ja_st_placeholder(inputs)
	return zh_st_placeholder(inputs)
};